<h1 class="page-header"><i class="fa fa-check-square-o" aria-hidden="true"></i>&nbsp;GTIN Validation Sets</h1>

<div class="container-fluid">

	<div class="tab-content">
		<div class="page-button">
			<!-- ACTIONS -->
			
				<!--Add Button -->
			<button (click)="addClicked()" class="btn btn-primary" type="button"><i class="fa fa-plus" aria-hidden="true"></i>
					ADD NEW</button>
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
					<i class="fa fa-wrench"></i> ACTIONS <span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li (click)="importValidationClicked()"><a><em class="fa fa-plus"></em> IMPORT FROM FILE</a></li>
					<li (click)="onDelete()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-remove"></em> DELETE</a></li>	
				</ul>
			</div>
			
			<!-- Filter -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li (click)="setFilterGtinValidationSet(null, null)"><a>REMOVE FILTER</a></li>
				<li (click)="setFilterGtinValidationSet('Name', 'name')"><a>Name</a></li>
			</ul>
		</div>
		<div *ngIf="filterColumnGtin != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameGtin }}
		</div>
		<div *ngIf="filterColumnGtin != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringGtin" (ngModelChange)="filterStringChangedGtin()">
		</div>
			
			<!-- RESULTS PER PAGE -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
					<em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForGtin(value)"
						[class.active]="value === selectedPageSizeValueForGtin"
						>
						<a>{{ value }}</a>
					</li>
				</ul>
			</div>
		</div>

		<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid" role="grid">
			<thead>
				<tr role="row" class="tablesorter-headerRow">
					<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0"
					scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label=": No sort applied, activate to apply an ascending sort"
					style="user-select: none; width: 20px">
					<div class="tablesorter-header-inner">
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
								[checked]="isAllSelected()" (change)="selectAll($event)"><label for="checkbox"></label>
						</div>
					</div>
				</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
						aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">NAME</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader"
						aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">CREATION DATE</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Groups: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">UPDATE DATE</div>
					</th>
				</tr>
			</thead>
			<tbody aria-live="polite" aria-relevant="all">
				<ng-container
					*ngFor="let gtinHeader of gtinHeaders | paginate: {id: 'gtin_pagination', itemsPerPage: selectedPageSizeValueForGtin, currentPage: currentPageForGtin, totalItems: totalNumberOfGtin }">
					<tr>
						<td>
							<div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="gtinHeader.selected"><label
									for="checkbox"></label></div>
						</td>
						<td (click)="viewGtinValidationSetClicked(gtinHeader.name)">{{ gtinHeader.name }}</td>
						<td (click)="viewGtinValidationSetClicked(gtinHeader.name)">{{ gtinHeader.createTs | date:"M/d/yyyy h:mm a" }}</td>
						<td (click)="viewGtinValidationSetClicked(gtinHeader.name)">{{ gtinHeader.modifiedTs | date:"M/d/yyyy h:mm a" }}</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
		<pagination-controls class="pagination" id="gtin_pagination" (pageChange)="pageChanged($event)" [directionLinks]="true"
			nextLabel="Next" previousLabel="Prev" [autoHide]="true">
		</pagination-controls>
    </div>
</div>
<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteGtinValidationSets()"></app-confirm-delete-dialog>
<app-gtin-dialog #gtinDialog ></app-gtin-dialog>
<app-view-gtin-dialog #viewGtinDialog></app-view-gtin-dialog>



